export const FILTERS_STORAGE_SUFFIX = '_filters';
export const VIEW_ID_STORAGE_SUFFIX = '_selectedViewId';
export const SORT_STORAGE_SUFFIX = '_sort';
